<template>
    <div class="popup" id="popup">
      <div class="popup__content popup--animate">
        <div class="popup__header">
          <svg class="popup__icon">
            <use href="@/assets/sprite.svg#icon-user"></use>
          </svg>
          <h1 class="heading-tertiary">{{ $t('popup.user.add.title') }}</h1>
        </div>
        <div class='popup__form'>
          <form @submit.prevent="addUser" class="form" ref="addUser-form" id="addUserForm">
            <div class="form__grouprow">
              <div class='userpopup__entry'>
                <Entry v-model="name" required indicator="form.name"></Entry>
                <Entry v-model="firstname" required indicator="form.firstname"></Entry>
                <Entry v-model="email" required :maskOnValue='hasToBeAnEmail' indicator="form.email"></Entry>
                <Entry v-model="password" typeField='password' required :maskOnValue='hasToBeAValidPassword' indicator="form.password"></Entry>
              </div>
              <div class="form__group u-margin-left-medium">
                <div class="userpopup__roles">
                  <span class="userpopup__roles-label">{{ $t('popup.user.add.role.label') }}</span>
                  <div class="userpopup__roles-list">
                    <div v-for="(role, index) in rolesList" :key="role._id">
                      <input class="userpopup__checkbox-button" type="checkbox" :value="role._id" :id="index" v-model="role.checked">
                      <label class="userpopup__checkbox-label u-pointer" :for="index">{{ role.name }}</label>
                    </div>
                  </div>
                </div>
                <div class="form__group-indicator">
                  <label class="form__label">
                    {{ $t('popup.user.add.role.indicator') }}
                  </label>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="popup__footer">
          <button class="popup__link u-pointer" type="button" form="addUserForm" @click='close'>{{ $t('popup.user.add.cancelAction') }}</button>
          <button class="popup__link u-pointer" type="submit" form="addUserForm">{{ $t('popup.user.add.confirmAction') }}</button>
        </div>
      </div>
    </div>
</template>

<script>
import { HTTP_CLIENT } from '@/axios-wrapper'
import Entry from '@/components/Entry'
import { formMixin } from '@/components/Mixins/Form'
import { toastMixin } from '@/components/Mixins/Toast'

export default {
  data: function () {
    return {
      name: '',
      firstname: '',
      email: '',
      password: '',
      rolesList: [],
      user: ''
    }
  },
  components: {
    Entry
  },
  mixins: [formMixin, toastMixin],
  methods: {
    close () {
      this.$emit('popup:close')
      this.$store.commit('user/SHOW_ADD_USER_POPUP', false)
    },
    async addUser () {
      if (this.$el.querySelectorAll('[data-entry-not-valid]').length) return
      try {
        let { data } = await HTTP_CLIENT.post(`user`, {
          email: this.email,
          password: this.password,
          name: this.name,
          firstname: this.firstname
        })
        this.close()
        this.user = data
        this.setRoles()
        this.sendSuccessToast(this.$t('feedback-ok.user.add', { firstname: this.firstname, name: this.name }))
      } catch (error) {
        this.sendErrorToast(this.$t('feedback-err.user.add', { firstname: this.firstname, name: this.name }))
      }
    },
    async getRoles () {
      try {
        let { data } = await HTTP_CLIENT.get('groupAbility?sort=name')
        this.rolesList = data
      } catch (error) { console.log(error) }
    },
    async setRoles () {
      let roles = this.rolesList.filter(item => item.checked).map(id => id._id)
      if (roles.length > 0) {
        try {
          await HTTP_CLIENT.put(`user/${this.user._id}/groupAbility`, {
            ids: roles
          })
        } catch (error) { console.log(error) }
      }
    }
  },
  mounted () {
    this.getRoles()
  }
}
</script>
